class Controller {
  constructor(Chartie) {
    "ngInject";

    this.Chartie = Chartie;
  }
  $onInit() {
    const field = this.field ? this.field : "rating";
    const height = this.height ? Number(this.height) : 350;
    const tooltipContent = this.tooltipContent ? this.tooltipContent : "stars";

    this.avg = this.avg ? this.avg.toFixed(2) : null;
    this.data = this.Chartie.sortByValue(this.data);
    this.options = this.Chartie.getOptionsWithDefault(this.options, {
      chart: {
        height,
        noData: "",
        donut: true,
        donutRatio: 0.3,
        type: "pieChart",
        x: (d) => `${d[field]} ${tooltipContent}`,
        y: (d) => d.count,
        labelType: "percent",
        labelThreshold: "0.05",
        labelSunbeamLayout: true,
        showLegend: false,
        tooltip: {
          valueFormatter: (value) => value,
        },
        color: this.Chartie.pieChartColors,
        margin: {
          left: 0,
          bottom: 0,
          right: 0,
          top: 0,
        },
        dispatch: {
          renderEnd: () => {},
        },
      },
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/pieChart/pieChart.controller.js